import React from 'react';

import { View } from 'react-native';

import Animated, {
    SharedValue,
    useAnimatedStyle,
} from 'react-native-reanimated';

import { isPhone, isTablet, isTabletOrWeb, isWeb } from 'utils/responsiveness';

import galleryStyles from '../../styles';
import styles from './styles';

type Props = {
    opacitySharedValue: SharedValue<number>;
};

function GallerySkeletonLoading({ opacitySharedValue }: Props) {
    const animatedStyle = useAnimatedStyle(() => ({
        opacity: opacitySharedValue.value,
    }));

    return (
        <View>
            <Animated.View
                style={[galleryStyles.galleryPlaceholder, animatedStyle]}
            >
                <View
                    style={[
                        styles.root,
                        isPhone && styles.phoneRoot,
                        isTablet && styles.tabletRoot,
                        isWeb && styles.webRoot,
                    ]}
                >
                    {isPhone && (
                        <>
                            <View style={styles.phoneRow1} />
                            <View style={styles.phoneRow2} />
                            <View style={styles.phoneRow3} />
                            <View style={styles.phoneRow4} />
                            <View style={styles.phoneRow5} />
                        </>
                    )}
                    {isTabletOrWeb && (
                        <>
                            <View style={styles.tabletRow1} />
                            <View style={styles.tabletRow2} />
                            <View style={styles.tabletRow3} />
                            <View style={styles.tabletRow4} />
                            <View style={styles.tabletRow5} />
                        </>
                    )}
                </View>
            </Animated.View>
            <View
                style={[
                    galleryStyles.paginationDotContainer,
                    isPhone && galleryStyles.phoneDotsContainer,
                    isWeb && galleryStyles.webDotsContainer,
                ]}
            />
            {isTablet && <View style={styles.paginatedDot} />}
        </View>
    );
}

export default React.memo(GallerySkeletonLoading);
